import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useDomainConfig } from "@/contexts/DomainConfigContext";

const FAQSection = () => {
  const { config } = useDomainConfig();
  const phoneNumber = config?.customer_service || "";

  const faqs = [
    {
      question: "What is Southampton Port parking?",
      answer: "Secure parking near Southampton cruise terminals with Park and Stroll and Park and Ride options.",
    },
    {
      question: "What is Park and Stroll?",
      answer: "Park nearby and walk to the terminal in a short time.",
    },
    {
      question: "How does Park and Ride work?",
      answer: "Park at a secure location and use a shuttle transfer to the port.",
    },
    {
      question: "Is the parking secure?",
      answer: "Yes, parking areas are monitored and managed for customer peace of mind.",
    },
    {
      question: "Should I book in advance?",
      answer: "Yes, advance booking is recommended for best prices and availability.",
    },
  ];
  return (
    <section id="faq" className="py-16 md:py-24 bg-cream">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">Frequently Asked Questions</h2>
            <p className="text-muted-foreground mb-8 text-justify">Quick answers about our Southampton Port parking services.</p>

            <Accordion type="single" collapsible className="space-y-3">
              {faqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="faq-item bg-card rounded-xl px-6 border-0 shadow-soft"
                >
                  <AccordionTrigger className="text-left font-semibold text-foreground hover:no-underline py-5">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground pb-5 text-justify">{faq.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>

            <div className="mt-6">
              <Link to="/faqs">
                <Button
                  variant="outline"
                  className="border-primary text-primary hover:bg-primary hover:text-primary-foreground"
                >
                  View More FAQs
                </Button>
              </Link>
            </div>
          </div>

          <div className="lg:sticky lg:top-32">
            <div className="bg-card rounded-2xl p-8 shadow-medium text-center">
              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6">
                <Phone className="w-8 h-8 text-primary" />
              </div>
              <h3 className="text-2xl font-bold text-foreground mb-4">Still Have Questions?</h3>
              <p className="text-muted-foreground mb-6">Our support team is ready to help with your Southampton Port parking booking.</p>
              {phoneNumber && (
                <>
                  <a href={`tel:${phoneNumber.replace(/\s/g, "")}`}>
                    <Button className="w-full h-12 text-lg bg-primary hover:bg-primary/90 text-primary-foreground font-semibold">
                      <Phone className="w-5 h-5 ltr:mr-2 rtl:ml-2 text-white" />
                      Call Us Now
                    </Button>
                  </a>
                  <p className="text-primary font-semibold mt-4">{phoneNumber}</p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
